module.exports = __webpack_public_path__ + "static/media/mobile_third_img.f52fda9b.png";